/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scanned: NonNullable<unknown>, expected: NonNullable<unknown> }} Pxk_Sp_Scan_MismatchInputs */

const vi_pxk_sp_scan_mismatch = /** @type {(inputs: Pxk_Sp_Scan_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sai lô. Đã quét ${i?.scanned}, cần lấy ${i?.expected}`)
};

/**

* @param {Pxk_Sp_Scan_MismatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pxk_sp_scan_mismatch = /** @type {((inputs: Pxk_Sp_Scan_MismatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pxk_Sp_Scan_MismatchInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pxk_sp_scan_mismatch(inputs)
});